import { render } from "./COIActionBarDestroyedByCustoms.vue?vue&type=template&id=dd2517b0"
import script from "./COIActionBarDestroyedByCustoms.vue?vue&type=script&lang=js"
export * from "./COIActionBarDestroyedByCustoms.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__